"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5649],{

/***/ 2384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6008);







var variants = {
    sizes: {
        small: "h-6",
        medium: "h-9",
        large: "h-12"
    },
    backgroundColor: {
        white: "chip-bg-color [&.chip-bg-color]:bg-mglGray50",
        black: "chip-bg-color [&.chip-bg-color]:bg-mglGray900",
        green: "chip-bg-color [&.chip-bg-color]:bg-mglGreen500"
    },
    color: {
        black: "text-mglGray900",
        white: "chip-color [&.chip-color]:text-mglGray50 [&.chip-color]:[&_svg]:fill-mglGray50"
    },
    hover: {
        white: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray50 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        black: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray900 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50",
        gray: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray200 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        green: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGreen600 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50"
    },
    borderColor: {
        gray: "chip-border-color [&.chip-border-color]:border-mglGray900/20 hover:[&.chip-border-color]:border-mglGray50",
        black: "border-mglGray900/20",
        white: "chip-border-color [&.chip-border-color]:border-mglGray50/20",
        green: "chip-border-color [&.chip-border-color]:border-mglGreen500 hover:[&.chip-border-color]:border-mglGreen600"
    }
};
function Chip(param) {
    var texto = param.texto, prepIcon = param.prepIcon, posIcon = param.posIcon, _link = param.link, link = _link === void 0 ? "#" : _link, _color = param.color, color = _color === void 0 ? undefined : _color, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? undefined : _backgroundColor, backgroundImage = param.backgroundImage, _overlayOpacity = param.overlayOpacity, overlayOpacity = _overlayOpacity === void 0 ? 60 : _overlayOpacity, _chipSize = param.chipSize, chipSize = _chipSize === void 0 ? "small" : _chipSize, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? undefined : _borderColor, _title = param.title, title = _title === void 0 ? "" : _title, _highlightedText = param.highlightedText, highlightedText = _highlightedText === void 0 ? "" : _highlightedText, className = param.className, onClick = param.onClick, _hover = param.hover, hover = _hover === void 0 ? undefined : _hover, _rel = param.rel, rel = _rel === void 0 ? "" : _rel, _target = param.target, target = _target === void 0 ? "_self" : _target;
    var isValidLink = link[0] !== "#" && !/^\/\//.test(link) && link !== "";
    var Container = isValidLink ? (next_link__WEBPACK_IMPORTED_MODULE_2___default()) : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    var Tag = link !== "#" && link !== "" ? "a" : "div";
    var linkProps = {};
    if (isValidLink) {
        Object.assign(linkProps, {
            href: link,
            passHref: true,
            prefetch: false
        });
    }
    var backgroundStyle = backgroundImage ? {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, ".concat(overlayOpacity / 100, "), rgba(0, 0, 0, ").concat(overlayOpacity / 100, ")), url(").concat(backgroundImage, ")"),
        backgroundSize: "cover",
        backgroundPosition: "center"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, linkProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, link && link !== "#" && {
            href: link
        }), {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative flex cursor-pointer flex-row flex-nowrap items-center justify-center overflow-hidden rounded-[100px] border border-solid px-4 no-underline transition-all ease-in [&_path]:transition-colors [&_path]:ease-ease", variants.sizes[chipSize], !backgroundImage && variants.backgroundColor[backgroundColor], variants.color[color], variants.borderColor[borderColor], variants.hover[hover], backgroundImage && "text-white", className),
            style: backgroundStyle,
            rel: rel,
            title: title,
            onClick: onClick,
            target: target,
            children: [
                !!prepIcon && typeof prepIcon === "string" && (prepIcon === "chevron-down" || prepIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(prepIcon),
                        width: 16
                    })
                }) : !!prepIcon && typeof prepIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: prepIcon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "relative mt-[-2px] whitespace-nowrap text-center text-xs no-underline",
                            children: texto
                        }),
                        !!highlightedText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-base font-semibold leading-none",
                            children: highlightedText
                        })
                    ]
                }),
                !!posIcon && typeof posIcon === "string" && (posIcon === "chevron-down" || posIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1 [&_svg]:w-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(posIcon),
                        width: 16
                    })
                }) : !!posIcon && typeof posIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1",
                    children: posIcon
                })
            ]
        }))
    }));
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 2747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bL": function() { return /* binding */ BillboardContainer; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "hn": function() { return /* binding */ ContentListNews; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    AdContainer: {
        noPadding: {
            true: "noPadding [&.noPadding]:p-0"
        },
        billboard: {
            true: "h-[250px] hidden tablet:flex"
        }
    },
    ContentListNews: {
        singleRow: {
            true: "grid-rows-[auto]"
        }
    }
};
var AdContainer = function(_param) {
    var children = _param.children, noPadding = _param.noPadding, billboard = _param.billboard, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "noPadding",
        "billboard"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex min-h-0 items-center justify-center bg-mglGray50 px-0 py-5", noPadding != undefined && variants.AdContainer.noPadding[noPadding.toString()], billboard != undefined && variants.AdContainer.billboard[billboard.toString()])
    }, rest), {
        children: children
    }));
};
var ContentListNews = function(_param) {
    var children = _param.children, singleRow = _param.singleRow, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "singleRow"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("ml-0 grid grid-cols-1 grid-rows-2 gap-5 [grid-auto-columns:1fr] tablet:ml-auto tablet:grid-cols-2 desktop:grid-cols-3 [&_a]:mx-0 [&_a]:my-5 [&_a]:no-underline ", singleRow != undefined && variants.ContentListNews.singleRow[singleRow.toString()])
    }, rest), {
        children: children
    }));
};
var BillboardContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "m-0 hidden tablet:mx-[-8.335%] tablet:my-0 tablet:flex"
    }, rest), {
        children: children
    }));
};


/***/ }),

/***/ 2835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsTimeLine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5877);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9659);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2153);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6008);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable jsx-a11y/anchor-is-valid */ 







var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_5___default()().publicRuntimeConfig;
var icons = {
    video: "mdi:video",
    podcast: "mdi:microphone",
    webStories: "mdi:view-carousel"
};
function NewsTimeLine(param) {
    var news = param.news, _image = param.image, image = _image === void 0 ? true : _image, _effectImage = param.effectImage, effectImage = _effectImage === void 0 ? true : _effectImage, _title = param.title, title = _title === void 0 ? true : _title, propsTitle = param.propsTitle, _autor = param.autor, autor = _autor === void 0 ? false : _autor, propsAutor = param.propsAutor, metaInfo = param.metaInfo, propsMetaInfo = param.propsMetaInfo, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _url = param.url, url = _url === void 0 ? null : _url, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag;
    var ref;
    var variants = {
        ItemList: {
            effectImage: {
                true: "[&_.image-container]:hover:scale-105",
                false: ""
            },
            colorInHover: {
                true: "transition-colors duration-300 ease-ease [&_h3]:hover:text-mglBlue400",
                false: ""
            }
        },
        Image: {
            imgRounded: {
                true: "rounded-half border-[3px] border-solid border-mglGray200",
                false: ""
            }
        },
        Title: {
            autorNoMargin: {
                true: "tablet:m-0 mt-0",
                false: ""
            }
        }
    };
    var currentSpan = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var newsListContainerSpan = currentSpan && currentSpan.startChild({
        op: "newsListContainer"
    });
    var Heading = headingTag;
    url || (url = news.url);
    if (isSubDomain && !url.match(/^https?:/)) {
        url = "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(url);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("relative mx-0 mb-0 mt-4 hover:cursor-pointer tablet:my-4 [&_a]:text-[inherit]", propsTitle.altColorInHover && !!propsTitle.colorHover && variants.ItemList.colorInHover[(propsTitle.altColorInHover && !!propsTitle.colorHover).toString()], effectImage != undefined && variants.ItemList.effectImage[effectImage.toString()]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: url,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    rel: news.id,
                    title: news.titulo,
                    className: "jc",
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "box relative flex overflow-hidden rounded-lg",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "image-container relative flex h-full w-full transition-transform duration-300 ease-ease [&>figure]:aspect-video",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        src: news.imagem.url,
                                        alt: news.titulo,
                                        blurhash: news.imagem.blurhash
                                    })
                                }),
                                autor && propsAutor && propsAutor.image && propsAutor.imgInImage && news.colunista && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-2 left-2 h-10 w-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-auto w-full object-cover", propsAutor.imgRounded != null && variants.Image.imgRounded[propsAutor.imgRounded.toString()]),
                                        src: news.colunista.imagem.url,
                                        alt: news.autor,
                                        width: 40,
                                        height: 40
                                    })
                                }),
                                (news.tipo === "video" || news.tipo === "webStories" || news.tipo === "podcast") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-[10px] left-[10px] z-[2] flex h-10 w-10 items-center justify-center rounded-half border-[6px] border-solid border-[#999] bg-[#999] text-[2.5rem]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        icon: icons[news.tipo],
                                        width: "1em",
                                        color: _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
                                    })
                                })
                            ]
                        }),
                        autor && propsAutor && propsAutor.image && !propsAutor.imgInImage && news.colunista && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative -bottom-2 mb-4 ml-0 mr-2 mt-0 inline-block h-10 w-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-auto w-full object-cover", propsAutor.imgRounded != null && variants.Image.imgRounded[propsAutor.imgRounded.toString()]),
                                src: news.colunista.imagem.url,
                                alt: news.autor
                            })
                        }),
                        autor && propsAutor && propsAutor.text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "mx-0 mb-2 mt-4 inline-block text-xs text-black/40",
                            children: news.autor
                        }),
                        metaInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-[10px] mt-5 flex flex-row text-xs leading-none",
                            children: [
                                propsMetaInfo && propsMetaInfo.age && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "flex flex-row items-center font-medium text-black/40 [&_svg]:mr-[2px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            icon: "mdi:clock-outline",
                                            width: "12",
                                            height: "12"
                                        }),
                                        news.idade
                                    ]
                                }),
                                propsMetaInfo && propsMetaInfo.age && propsMetaInfo.category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mx-1 my-0 h-auto border-0 border-l-[0.5px] border-solid border-[#999]"
                                }),
                                propsMetaInfo && propsMetaInfo.category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-medium uppercase text-black/40",
                                    children: news.categoria
                                })
                            ]
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("mt-4 text-lg font-medium text-mglGray900 tablet:mx-0 tablet:mb-0", (propsAutor && !!propsAutor.text || metaInfo && !!propsMetaInfo) && variants.Title.autorNoMargin.true),
                            style: propsTitle.color ? {
                                color: propsTitle.color
                            } : {},
                            children: news.titulo
                        })
                    ]
                })
            }),
            newsListContainerSpan && newsListContainerSpan.finish()
        ]
    });
}


/***/ }),

/***/ 9879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Titulo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



function Titulo(param) {
    var texto = param.texto, color = param.color, urlRedirect = param.urlRedirect, showChip = param.showChip, alignRight = param.alignRight, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag, _noPadding = param.noPadding, noPadding = _noPadding === void 0 ? false : _noPadding;
    var titleStyles = "flex items-center text-2xl text-left font-medium";
    var Heading = headingTag;
    var chipProps = {
        black: {
            color: "black",
            border: "black",
            title: "text-mglGray900",
            hover: "black"
        },
        white: {
            color: "white",
            border: "white",
            title: "text-mglGray50",
            hover: "white"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-center pb-2 [&>svg]:ml-[5px] [&>svg]:transition-all [&>svg]:duration-200 hover:[&>svg]:ml-[10px]", noPadding && "p-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(titleStyles, !alignRight && "mr-2", chipProps[color].title),
                children: texto
            }),
            alignRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-auto"
            }),
            showChip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                texto: "ver tudo",
                color: chipProps[color].color,
                chipSize: "medium",
                posIcon: "chevron-right",
                title: "ver tudo - ".concat(texto),
                borderColor: chipProps[color].border,
                link: urlRedirect,
                hover: chipProps[color].hover
            })
        ]
    });
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ }),

/***/ 804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var PageDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (PageDataContext);


/***/ }),

/***/ 6874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ sponsorCategoryData; },
/* harmony export */   "P2": function() { return /* binding */ enableSponsoredCategories; },
/* harmony export */   "PV": function() { return /* binding */ getEditorialCategory; },
/* harmony export */   "Rt": function() { return /* binding */ getSponsoredCategory; },
/* harmony export */   "SU": function() { return /* binding */ getSponsoredCategoryOrTypeWithStringToInternal; },
/* harmony export */   "xu": function() { return /* binding */ isSponsoredOrEditorialToInternal; }
/* harmony export */ });
/* unused harmony exports sponsoredCategoriesUri, getEditorialCategoryWithStringToInternal */
var sponsorCategoryData = {
    tutoriais: [
        {
            url: "https://www.kaspersky.com.br/premium?reseller=br_eg-mf_acq_ona_dis__onl_b2c_canaltech_ban_______&utm_content=banner%7Cgeneric&utm_source=canaltech&utm_medium=display&utm_term=youtube&utm_campaign=",
            title: "Ir para o site do Kaspersky!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                }
            }
        }, 
    ],
    smartphone: [
        {
            url: "https://www.motorola.com.br/",
            title: "Ir para o site da Motorola!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                }
            }
        }, 
    ]
};
var enableSponsoredCategories = [
    "tutoriais",
    "smartphone"
];
var sponsoredCategoriesUri = (/* unused pure expression or super */ null && ([
    "tutoriais",
    "smartphone"
]));
var editorialCategoriesCtupUri = [
    "hardware",
    "games",
    "ctup",
    "notebook"
];
var sponsoredCategoriesTutorialsTitle = [
    "Tutoriais"
];
var sponsoredpublicationType = [
    "4"
];
var editorialCategoriesCtupTitle = [
    "Hardware",
    "Games",
    "Notebook"
];
var editorialCategoriesCtAutoTitle = [
    "Ve\xedculos",
    "Carros",
    "Mobilidade Urbana",
    "Ve\xedculos Aut\xf4nomos"
];
var getSponsoredCategory = function(singleCategory) {
    if (singleCategory === "tutoriais") return "tutoriais";
    if (singleCategory === "smartphone") return "smartphone";
    return undefined;
};
var getEditorialCategory = function(singleCategory) {
    if (editorialCategoriesCtupUri.includes(singleCategory)) return "ctup";
    if (singleCategory === "eletro" || singleCategory === "ct-eletro") return "eletro";
    if (singleCategory === "ctauto") return "ctauto";
    return undefined;
};
var isSponsoredOrEditorialToInternal = function(mainCategory, categories) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    if (sponsoredCategoriesTutorialsTitle.includes(mainCategory)) return "sponsored";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) return "editorial";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) return "editorial";
    if (mainCategory === "CT Eletro") return "editorial";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) return "sponsored";
    if (sponsoredpublicationType.includes(publicationType)) return "sponsored";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) return "editorial";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) return "editorial";
    if (categories.includes("CT Eletro")) return "editorial";
    return undefined;
};
var getSponsoredCategoryOrTypeWithStringToInternal = function(categories, mainCategory) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    var category = undefined;
    if (mainCategory && sponsoredCategoriesTutorialsTitle.includes(mainCategory)) category = "tutoriais";
    if (sponsoredpublicationType.includes(publicationType)) category = "tutoriais";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) category = "tutoriais";
    if (!enableSponsoredCategories.includes(category)) return undefined;
    return category;
};
var getEditorialCategoryWithStringToInternal = function(categories, mainCategory) {
    var category = undefined;
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) category = "ctup";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) category = "ctauto";
    if (categories.includes("CT Eletro")) category = "eletro";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) category = "ctup";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) category = "ctauto";
    if (mainCategory === "CT Eletro") category = "eletro";
    return category;
};


/***/ }),

/***/ 3493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ LastNewsRoot; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Home_FeaturedLastNews__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2826);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7590);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable camelcase */ 



var __N_SSP = true;
function LastNewsRoot(param) {
    var navBarData = param.navBarData, tagsData = param.tagsData, segmentacoes = param.segmentacoes, manualTitle = param.manualTitle, manualRouting = param.manualRouting, timelineData = param.timelineData, homeData = param.homeData, routeType = param.routeType, route = param.route, schema = param.schema;
    var AdsTypeGenerators = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return __webpack_require__.e(/* import() */ 8463).then(__webpack_require__.bind(__webpack_require__, 2444));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(2444)
                ];
            }
        },
        ssr: false
    });
    var title = manualTitle || "\xdaltimas Not\xedcias";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        layoutData: {
            segmentacoes: segmentacoes,
            tagsData: tagsData,
            navBarData: navBarData,
            schema: schema
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Home_FeaturedLastNews__WEBPACK_IMPORTED_MODULE_2__["default"], {
            featuredLastNewsData: (timelineData === null || timelineData === void 0 ? void 0 : timelineData.timeline) || (homeData === null || homeData === void 0 ? void 0 : homeData.timeline),
            rootPage: manualRouting || "ultimas",
            textTitle: title,
            headingTag: "h1",
            routeType: routeType || "ultimas",
            route: route || "/ultimas"
        })
    });
}


/***/ })

}]);